import StackedBarChart from '@/components/molecules/Charts/StackedBarChart';
import { WalletUnderlyingYieldBearingAssetInterface } from '@/interfaces';
import { FC, useMemo } from 'react';
interface Props {
  assets: WalletUnderlyingYieldBearingAssetInterface[];
  noOfItemsToShow: number;
}
const PortfolioAssetsChart: FC<Props> = ({ assets, noOfItemsToShow }) => {
  const totalPortfolioPercentage = useMemo(() => {
    return assets.reduce((sum, token) => {
      return sum + (token.shareOfPortfolio ?? 0);
    }, 0);
  }, [assets]);
  const chartItems = useMemo(() => {
    if (noOfItemsToShow === 0 || assets.length <= noOfItemsToShow) {
      return assets.map((token) => ({
        width: ((token.shareOfPortfolio ?? 0) / totalPortfolioPercentage) * 100,
        color: token.color,
      }));
    }
    const topTokens = assets.slice(0, noOfItemsToShow - 1);
    const otherTokens = assets.slice(noOfItemsToShow - 1);
    const otherTotalPercentage = otherTokens.reduce(
      (sum, token) => sum + (token.shareOfPortfolio ?? 0),
      0,
    );
    const otherToken = {
      width: (otherTotalPercentage / totalPortfolioPercentage) * 100 || 0,
      color: assets[Math.max(0, noOfItemsToShow - 1)]?.color ?? 'bg-gray-500',
    };
    return [
      ...topTokens.map((token) => ({
        width: ((token.shareOfPortfolio ?? 0) / totalPortfolioPercentage) * 100,
        color: token.color,
      })),
      otherToken,
    ];
  }, [assets, noOfItemsToShow, totalPortfolioPercentage]);
  return <StackedBarChart items={chartItems} />;
};
export default PortfolioAssetsChart;
